export const getHeaderUiState = state => state.headerUiState;
export const isActionsPopupVisible = state => getHeaderUiState(state).isActionsPopupVisible;
